import {getSocket} from '../sockets'
import {I18n} from "react-redux-i18n";

export function socketEmit(action, ...args) {
  const socket = getSocket();
  if (!socket) return;

  socket.emit(action, ...args)
}

export function socketEmitWithCallback(action, data, callback) {
  const socket = getSocket();
  if (!socket) return;

  socket.emit(action, data, callback)
}

export function promisifiedSocketEmit(action, data) {
  return new Promise((resolve) => {
    console.log('<=', action, {...data, otc_token: '--', auth_token: '--'})
    socketEmitWithCallback(action, data, (__, result) => {
      console.log('->', action, result)
      resolve(result)
    })
  })
}

export function parseUrl(url) {
  const parser = document.createElement('a');
  parser.href = url;
  return {
    origin: parser.origin,
    pathname: parser.pathname,
  }
}

export function getRandomString(length, regexp) {
  function getRandomSymbol() {
    let s = '';
    do {
      s = String.fromCharCode(Math.round(Math.random() * (122 - 48)) + 48);
    } while (!regexp.test(s));
    return s;
  }

  regexp = regexp || /\w/;
  var res = '';
  for (var i = 0; i < length; i++) {
    res += getRandomSymbol();
  }
  return res;
}

export function getLanguageScope(scope) {
  return function (key) {
    return I18n.t(`${scope}.${key}`)
  }
}

export function currency(val, symbol) {
  const v = number(val);
  const p = Math.abs(v).toFixed(2).split('.');
  return string(v < 0 && '-') + string(symbol) + p[0].split("").reverse().reduce(function (acc, num, i) {
    return num + (i && !(i % 3) ? "," : "") + acc;
  }, "") + "." + p[1];
}

export function number(val) {
  return Math.round((+val || 0) * 100000000) / 100000000;
}

export function string(val) {
  return String(val || '');
}

export function boolean(val) {
  return Boolean(val || '');
}

export function digitsFromString(str) {
  return ("" + str).replace(/\D/g, '')
}

export const C = currency;
export const S = string;
export const N = number;
export const B = boolean;
export const DFS = digitsFromString;

export function capitalize(text) {
  return string(text).toLowerCase().replace(/\b./g, a => a.toUpperCase());
}

export function createLazyExecution(callback, timeout) {
  let timer = -1;
  return function (...params) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      callback(...params)
    }, timeout);
  }
}

export function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export function b64toBlob(b64Data, contentType, sliceSize) {
  contentType = contentType || '';
  sliceSize = sliceSize || 512;

  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, {type: contentType});
}

export function restrictInvalidChars(event) {
  if (!event) return false;

  let key = '';

  console.log(event);

  if (event.type === 'paste') {
    key = event.clipboardData.getData('text/plain');
  } else {
    key = event.keyCode || event.which;
    key = String.fromCharCode(key);
  }

  var regex = /[0-9]|\./;
  if (!regex.test(key)) {
    event.returnValue = false;
    if (event.preventDefault) event.preventDefault();
    return false;
  }

  return true;
}

export function getCardData(track1, track2) {
  var result = {};
  var track1Match = (track1 || '').match(/^%?([A-Z])([0-9]{1,19})\^([^\^]{2,40})\^([0-9]{4}|\^)([0-9]{3}|\^)([^\?]*)\??$/) || [];
  if (!track1Match || track1Match.length < 7) return null;
  result.cardFormatCode = track1Match[1];
  result.cardAccountNumber = track1Match[2];
  result.cardHolderName = track1Match[3];
  result.cardExpirationData = track1Match[4] === '^' ? null : track1Match[4];
  result.cardServiceCode = track1Match[5] === '^' ? null : track1Match[5];
  result.cardDiscretionaryData = track1Match[6];
  var track2Match = (track2 || '').match(/^;?([0-9]{1,19})=([0-9]{4}|=)([0-9]{3}|=)([^\?]*)\??$/) || [];
  if (!track2Match || track2Match.length < 5) return null;
  result.cardAccountNumber = track2Match[1] || result.cardAccountNumber;
  result.cardExpirationData = (track2Match[2] === '=' ? null : track2Match[2]) || result.cardExpirationData;
  result.cardServiceCode = (track2Match[3] === '=' ? null : track2Match[3]) || result.cardServiceCode;
  result.cardDiscretionaryData = track2Match[4] || result.cardDiscretionaryData;
  result.track1 = track1;
  result.track2 = track2;
  return result;
}

export function createMessage(template, obj){
  let message = template;
  if(_.isEmpty(obj)) return message;

  _.each(obj, (v, k) => {
    message = message.replace(new RegExp('\\{{' + k + '\\}}', 'g'), v);
  });

  return message;
}

export function buildMessage(args, separator = '') {
  if(_.isObject(args)) args = Object.values(args);

  return _.compact(args).join(separator)
}


// WEBPACK FOOTER //
// ./src/helpers/index.js